
import { computed, defineComponent } from 'vue';

import store from '~store';

export default defineComponent({
  setup() {
    return {
      home: computed(() => store.getters.getBaseLogoRoute),
    };
  },
});
